'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useId, useRef, useState } from 'react';
import { Button } from './Button';
import { Popover as ShadPopover, PopoverContent, PopoverTrigger } from './ui/popover';
import { useCloseWhenTriggerHidden } from './useTriggerVisible';
export function Popover({ trigger, label, children, kind = 'panel', triggerVariant = 'ghost', triggerSize = 's', triggerIconOnly = false, triggerClassName, className = 'min-w-72', placement = 'bottom-end', onOpenChange, }) {
    const id = `popover-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`;
    const [open, setOpen] = useState(false);
    const triggerRef = useRef(null);
    const close = useCallback(() => {
        setOpen(false);
        onOpenChange?.(false);
    }, [onOpenChange]);
    /* Кнопка уехала из видимой области - панель уходит с ней. */
    useCloseWhenTriggerHidden(triggerRef, open, close);
    return (_jsxs(ShadPopover, { open: open, onOpenChange: (next) => {
            setOpen(next);
            onOpenChange?.(next);
        }, children: [_jsx(PopoverTrigger, { asChild: true, children: _jsx(Button, { ref: triggerRef, id: id, variant: triggerVariant, size: triggerSize, iconOnly: triggerIconOnly, className: triggerClassName, "aria-haspopup": kind === 'menu' ? 'menu' : 'dialog', "aria-label": label, children: trigger }) }), _jsx(PopoverContent, { "data-popover-panel": true, align: placement === 'bottom-start' ? 'start' : 'end', className: `max-h-[70vh] overflow-y-auto p-0 ${className}`, role: kind === 'menu' ? 'menu' : undefined, "aria-orientation": kind === 'menu' ? 'vertical' : undefined, "aria-labelledby": id, onClick: (event) => {
                    /*
                     * Пункты, помеченные `data-popover-close`, закрывают панель.
                     *
                     * Ссылка меню уводит на другой адрес, и панель обязана уйти вместе
                     * с ней; кнопка внутри панели, наоборот, оставляет её открытой.
                     * Признак ставит тот, кто пишет содержимое, - слой не угадывает.
                     */
                    if (event.target.closest('[data-popover-close]') !== null) {
                        /* Закрытие ВСЕГДА через `close`: оно и меняет состояние, и
                           сообщает наружу. Прямой `setOpen(false)` при управляемом
                           состоянии до владельца не доходит - панель уведомлений
                           оставалась на втором уровне и при следующем открытии
                           показывала деталь вместо списка. */
                        close();
                    }
                }, children: children })] }));
}
//# sourceMappingURL=Popover.js.map